import React from 'react';
import { ErrorBoundaryTW } from '../../../tailwindComponents/errorBoundary/ErrorBoundaryTW';
import { OrdersCreatedToday } from './OrdersCreatedToday';
import { OrdersClosingToday } from './OrdersClosingToday';
import { OrdersClosingTomorrow } from './OrdersClosingTomorrow';

export const DashboardKPIContainer: React.FC = () => {
  return (
    <ErrorBoundaryTW>
      <div className={'flex w-full flex-row justify-between gap-4'}>
        <OrdersCreatedToday />
        <OrdersClosingToday />
        <OrdersClosingTomorrow />
      </div>
    </ErrorBoundaryTW>
  );
};
